import { FormControl, FormLabel, HStack, Select } from "@chakra-ui/react";
import React from "react";

const FormikSelect = ({
  children,
  labelText,
  formik,
  field,
  isRequired = false,
  placeholder = "",
}) => {
  return (
    <FormControl isRequired={isRequired}>
      <HStack>
        <FormLabel whiteSpace="nowrap" mb={0}>
          {labelText}
        </FormLabel>
        <Select
          variant="filled"
          w="fit-content"
          {...formik.getFieldProps(field)}
          placeholder={placeholder}
        >
          {children}
        </Select>
      </HStack>
    </FormControl>
  );
};

export default FormikSelect;
